export default __webpack_public_path__ + "static/media/Vector2.5ebd2bad.svg";